'use client';

import moment, { Moment } from 'moment';
import { DateType } from '../models/date';

interface TimeTranslations {
    just_now: string;
    minute_ago?: string;  // "1분 전" (singular)
    minutes_ago: string;  // "{count}분 전"
    hour_ago?: string;    // "1시간 전" (singular)
    hours_ago: string;    // "{count}시간 전"
    day_ago?: string;     // "1일 전" (singular)
    days_ago: string;     // "{count}일 전"
    week_ago?: string;    // "1주 전" (singular)
    weeks_ago: string;    // "{count}주 전"
    year_ago?: string;    // "1년 전" (singular)
    years_ago: string;    // "{count}년 전"
}

// Default Korean translations
const DEFAULT_TRANSLATIONS: TimeTranslations = {
    just_now: '방금 전',
    minutes_ago: '분 전',
    hours_ago: '시간 전',
    days_ago: '일 전',
    weeks_ago: '주 전',
    years_ago: '년 전',
};

export const formatTime = (createdAt: DateType, translations: TimeTranslations = DEFAULT_TRANSLATIONS): string => {
    const currentTime = moment();
    let createAtTime: Moment;

    if (typeof createdAt === 'string') {
        createAtTime = moment(createdAt);
    } else if (createdAt instanceof Date) {
        createAtTime = moment(createdAt);
    } else {
        return '';
    }

    const timeDiff = currentTime.diff(createAtTime);
    const seconds = moment.duration(timeDiff).asSeconds();
    const minutes = moment.duration(timeDiff).asMinutes();
    const hours = moment.duration(timeDiff).asHours();
    const days = moment.duration(timeDiff).asDays();
    const weeks = moment.duration(timeDiff).asWeeks();
    const years = moment.duration(timeDiff).asYears();

    if (seconds < 60) {
        return translations.just_now;
    } else if (minutes < 60) {
        const floorMinutes = Math.floor(minutes);
        return floorMinutes === 1 && translations.minute_ago
            ? translations.minute_ago
            : `${floorMinutes}${translations.minutes_ago}`;
    } else if (hours < 24) {
        const floorHours = Math.floor(hours);
        return floorHours === 1 && translations.hour_ago
            ? translations.hour_ago
            : `${floorHours}${translations.hours_ago}`;
    } else if (days < 7) {
        const floorDays = Math.floor(days);
        return floorDays === 1 && translations.day_ago
            ? translations.day_ago
            : `${floorDays}${translations.days_ago}`;
    } else if (weeks < 52) {
        const floorWeeks = Math.floor(weeks);
        return floorWeeks === 1 && translations.week_ago
            ? translations.week_ago
            : `${floorWeeks}${translations.weeks_ago}`;
    } else {
        const floorYears = Math.floor(years);
        return floorYears === 1 && translations.year_ago
            ? translations.year_ago
            : `${floorYears}${translations.years_ago}`;
    }
};
